import { useState } from "react";
import Ropa from "../components/Ropa";
import './vestimenta.css'

export default function Vestimenta(props) {
  const [color, setColor] = useState(props.colors[0].color)

  function colors(e) {
    setColor(e.target.value)
  }
  return (
    <section className="Vestimenta">
      <div>
        <p><span className="block-left title-text p3">Vestimenta</span></p>
        <p><span className="block-left title-text p2">{props.gen}</span></p>
        <p><span className="block-left title-text p1">{props.desc}</span></p>
        <p><span className="block-left title-text p1">{props.acc}</span></p>
      </div>
      <div className="div-vestimenta">
        <Ropa type={props.type} colores={{ color1: color, color2: 'none' }} />
      </div>
      <div className="div-vestimenta">
        <table>
          <tbody>
            <tr>
              {
                props.colors.map((el, ind) => (
                  <td key={ind}><input
                    style={{ background: el.color }}
                    type="radio" name={props.name} defaultChecked={ind === 0 ? true : false} value={el.color} onClick={colors} />
                  </td>
                ))
              }
            </tr>
          </tbody>
        </table>


      </div>
    </section>
  )
}